	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
<div appMargin marginB="5">
      <div class="ui left labeled button" tabindex="0" (click)="collapseExisting = !collapseExisting">
      <a class="ui primary basic label">
        Add User
      </a>
      <div class="ui primary icon button">
      <i  [ngClass]="collapseExisting?'chevron down icon':'chevron up icon' "></i>
      </div>
      </div>




                  </div>
                         <div *ngIf="success || error" appMargin marginY="10px">
                          <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
                          <esl-message-toast [(message)]="error"></esl-message-toast>
                        </div>

    <div  [suiCollapse]="collapseExisting">
                  <div class="ui segment form"  [formGroup]="existingUserForm"  >
                          <div class="two fields">
                             <div class="field required" [ngClass]="displayFieldCssE('appUserId')">
                         <label>Select User</label>
                               <ng-template let-option #optionTemplate>
                                   <span *ngIf="!option.firstName && !option.lastName"> {{option.appUserEmail}} </span>
                                    <span *ngIf="option.firstName || option.lastName"> {{option.firstName}} {{option.lastName}}</span>
                              </ng-template>
                                                         <sui-select class="selection"
                               [optionsLookup]="userLookup"
                               valueField="appUserId"
                               labelField="name"
                               isSearchable="true"
                                  [optionTemplate]="optionTemplate"
                               formControlName="appUserId"
                               placeholder="Search to user"
                                   #multiSelectuser>
                                    <sui-select-option *ngFor="let option of multiSelectuser.filteredOptions"
                                                      [value]="option">
                                    </sui-select-option>
                              </sui-select>
                        </div>
                     <div class="field " [ngClass]="displayFieldCssE('userRole')">
                         <label>Select Role</label>
                                    <sui-select class="selection"
                               [options]="roles"
                               valueField="roleId"
                               labelField="roleName"
                               isSearchable="true"
                               formControlName="userRole"
                               placeholder="Search to select role"
                                   #multiSelectsy>
                                    <sui-select-option *ngFor="let option of multiSelectsy.filteredOptions"
                                                      [value]="option">
                                    </sui-select-option>
                              </sui-select>
                        </div>
                          </div>
                  <div class="fields">
                        <button class="ui fluid primary button" [disabled]="!existingUserForm.valid" (click)="submitExisting()">Add User To Department</button>
                  </div>
                  </div>
    </div>
<app-tabset>
            <div class="ui pointing secondary menu">
                <a class="item" appTabHeader="1">Users </a>
            </div>
            <div class="ui vertical basic segment" appTabContent="1">
                  <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
                        <div class="ui segment" *ngFor="let user of departmentUsers" appMargin marginB="5">
                                    <div fxLayout="row" fxLayoutAlign='space-between center' fxLayoutGap="15px">
                                          <div fxFlex="10%">
                                                <img class="ui circular tiny image" src="assets/avatar/1.jpg"/></div>
                                          <div fxFlex="grow">
                                                <h4 class="sub-header">{{user?.firstName}} {{user?.middleName}} {{user?.lastName}}</h4>
                                          </div>
                                                <div fxFlex="10%">
                                                <button class="ui tiny icon button" (click)="onDelete(user)">
                                                      <i class="ui trash icon"></i>
                                                </button>
                                                </div>
                                    </div>
                              </div>
                         </div>
            </div>
</app-tabset>



 </div>
      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done </button>

      </div>


